import CommHandler from '../utils/CommHandler';
import { getAuthHeader } from '../utils/utils';
import { config } from '../config';

/**
 * Fetch form by category and designation
 * @param {string} categoryId
 * @param {string} designationId
 * @returns {Promise<any>}
 */
export const getFormByCategoryAndDesignation = async (categoryId: string, designationId: string) => {
  const response = await CommHandler.request({
    url: `/evaluation/form/categorybydesignation?category_id=${categoryId}&designation_id=${designationId}`,
    method: 'GET',
  });
  return response;
};

/**
 * Fetch all forms
 * @param {number} page - Page number (0-indexed)
 * @param {number} limit - Number of items per page
 * @param {string} [search] - Optional search term
 * @returns {Promise<any>}
 */
export const getAllForms = async (page = 0, limit = 10, search = '') => {
  const response = await CommHandler.request({
    url: `${config.apiBaseUrl}/evaluation/forms?page=${page + 1}&limit=${limit}&search=${search}`,
    method: 'GET',
    headers: getAuthHeader,
  });
  return response;
};

/**
 * Fetch form by ID
 * @param {number} formId - The ID of the form to fetch
 * @returns {Promise<any>}
 */
export const getFormById = async (formId: number) => {
  const response = await CommHandler.request({
    url: `${config.apiBaseUrl}/evaluation/form/${formId}`,
    method: 'GET',
    headers: getAuthHeader,
  });
  return response;
};
